@if (canShowDetailsOfCreelPosition()) {
  <mat-card [class.can-show-warning]="canShowWarning()" class="flex-column full-height">
    <div class="full-height">
      <mat-card-content class="overflow-auto full-height">
        <article class="creel-position-details-container gap-16">
          <div class="flex-row flex-space-between gap-16">
            <h4>{{ 'TEXTILE_DATA.MATERIAL_SET.CREEL_POSITION' | bmsTranslate: {count: 1, position: getCreelPositionViewIndex()} }}</h4>
            @if (canShowWarning()) {
              <mat-icon svgIcon="error"></mat-icon>
            }
          </div>
          <div class="actions gap-8">
            @if (hasSelectedMaterialSetTypesOrGroups(creelPosition.horizontalPositionsOfCreelPosition)) {
              <div class="flex gap-8">
                @if (canShowDuplicate(creelPosition.horizontalPositionsOfCreelPosition)) {
                  <p class="url" (click)="duplicateSelectedMaterialSetTypesAndGroups()">
                    {{ 'GENERAL.ACTIONS.DUPLICATE' | bmsTranslate }}
                  </p>
                }
                <p appDataCy="group-selected-material-set-types-and-groups" class="url" (click)="groupSelectedMaterialSetTypesAndGroups()">{{ 'GENERAL.GROUP' | bmsTranslate: {count: 1} }}</p>
                <p appDataCy="delete-selected-material-set-types-and-groups" class="url" (click)="deleteSelectedMaterialSetTypesAndGroups(creelPosition.horizontalPositionsOfCreelPosition)">
                  {{ 'GENERAL.ACTIONS.DELETE' | bmsTranslate }}
                </p>
              </div>
            }

            @if (canEditMaterialSet) {
              <p class="url" (click)="addEmptyGroupToSelectedCreelPosition()">
                {{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'GENERAL.GROUP' | bmsTranslate: {count: 1} | lowercase} }}
              </p>
            }
          </div>
          <div class="flex-row sub-titles">
            <span class="flex-start-center full-width">
              {{ (isMaterialSetOfTypeColorSet() ? 'TEXTILE_DATA.COLOR.COLOR' : 'TEXTILE_DATA.YARN_TYPE.YARN_TYPE') | bmsTranslate: {count: 1} }}
            </span>
            <span class="flex-end-center">{{ 'GENERAL.AMOUNT' | bmsTranslate }}</span>
          </div>

          <div
            class="full-width full-height content"
            cdkDropList
            [cdkDropListConnectedTo]="droplistsRecursive"
            (cdkDropListDropped)="drop($event)"
            [cdkDropListData]="creelPosition.horizontalPositionsOfCreelPosition"
            id="droplistCreelPositions"
          >
            <div *ngFor="let entry of creelPosition.horizontalPositionsOfCreelPosition">
              <div cdkDrag class="cdk-draggable-item">
                <div *cdkDragPlaceholder class="drag-indicator"></div>
                @if (canShowMaterialType(entry)) {
                  <app-material-type
                    [horizontalPositionOfMaterialTypeCreelPosition]="entry"
                    [indexOfHorizontalPositionOfCreelPosition]="getPositionOfMaterialTypeCreel(entry)"
                    [canEditMaterialSet]="canEditMaterialSet"
                    (typeChanges)="emitCreelPositionChanges()"
                  ></app-material-type>
                }

                @if (entry.isGroup()) {
                  <app-material-type-group
                    [connectedDroplist]="droplistsRecursive"
                    [horizontalPositionOfGroupCreelPosition]="entry"
                    [horizontalPositionsOfCreelPosition]="creelPosition.horizontalPositionsOfCreelPosition"
                    [canShowError]="canShowError"
                    [canEditMaterialSet]="canEditMaterialSet"
                    [isDraggingOver]="isDraggingOver"
                    (groupChanges)="emitCreelPositionChanges()"
                  ></app-material-type-group>
                }
              </div>
            </div>
          </div>
        </article>

        @if (canShowCreelPreview()) {
          <article>
            <app-creel-preview [creelPositionWithColorsAndYarnTypes]="creelPositionWithColorsAndYarnTypes" [nameOfColorSet]="materialSet.name" [nameOfYarnSet]="materialSet.name"></app-creel-preview>
          </article>
        }
      </mat-card-content>
    </div>
  </mat-card>
}
